module.exports = __webpack_public_path__ + "static/media/hk.7428ec1c.svg";